var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_vm._m(0),_c('div',{staticClass:"login-page-content"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page-bg",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"login-page-glow login-page-glow--top"}),_c('div',{staticClass:"login-page-glow login-page-glow--bottom"}),_c('div',{staticClass:"login-page-grid"})])
}]

export { render, staticRenderFns }